import * as XLSX from "xlsx";

export const downloadExcel = <T extends Record<string, any>>(
    rows: T[],
    fileName: string,
    sheetName = "Sheet"
): void => {
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    XLSX.writeFile(workbook, fileName);
};